<script setup>
import {onMounted, ref} from "vue";
import Button from "../../components/forms/Button.vue";
import {getLoggedUser} from '@/services/AuthService';
import {createConfirmDialog} from "vuejs-confirm-dialog";
import {showSuccessMessage} from "@/helper";
import router from "@/router";
import {useDataTable} from "@/utils/datatableHelper";
import UserService from "@/services/UserService";
import CreateUpdateUserModal from "@/components/modals/CreateUpdateUserModal.vue";

import {useI18n} from 'vue-i18n'

const {t} = useI18n();

// nastavení tabulky (stránka, počet řádků, řazení, filtry) se pamatuje v localStorage pod klíčem USERS-INDEX
const datatableRef = ref(null);
const datatable = useDataTable(fetchUsers, 'name', 10, true, {}, 'USERS-INDEX', datatableRef);

const loggedUser = ref({});

const columns = ref([
  {
    label: t('usersIndex.name'),
    field: 'name',
    filterOptions: {
      enabled: true,
      skipDiacritics: true,
      placeholder: ' '
    }
  },
  {
    label: t('usersIndex.email'),
    field: 'email',
    filterOptions: {
      enabled: true,
      skipDiacritics: true,
      placeholder: ' '
    }
  },
  {
    label: '',
    field: 'action',
    sortable: false,
    html: true
  },
]);

onMounted(() => {
  //fetchUsers();
});

function fetchUsers(body) {
  body.filter['role'] = 'ADMIN';
  UserService.fetchRecords(body).then(response => {
    datatable.totalRecords.value = response.meta.total;
    datatable.rows.value = response.data;
    datatable.isLoading.value = false;
  });
}

function createUser() {
  const {reveal, onConfirm, onCancel} = createConfirmDialog(CreateUpdateUserModal, {});
  reveal();
  onConfirm((data) => {
    UserService.saveUser(data).then(response => {
      showSuccessMessage(response.message);
      datatable.fetchWithValues();
    });
  });
  onCancel(() => {
  });
}

function deleteUser(id) {
  UserService.deleteUser(id).then(response => {
    showSuccessMessage(response.message);
    datatable.fetchWithValues();
  });
}

function navigateTo(to) {
  router.push(to);
}

</script>

<template>
  <div class="page-section">
    <div class="page-section__heading">
      <div class="row">
        <div class="col-3">
          <a @click="router.back()" class="page-section__heading__back"><i class="mdi mdi-arrow-left"></i> {{ t('usersIndex.back') }}</a>
        </div>
        <div class="col-5 text-center">
          <div class="page-section__title">
            {{ t('usersIndex.users') }}
          </div>
        </div>
        <div class="col-4 d-flex justify-content-end">
          <Button :label="t('usersIndex.add_user')" icon="mdi-text-box-plus" @click="createUser()"></Button>
        </div>
      </div>

    </div>
  </div>
  <div class="page-section__content">
    <div class="mt-3">
      <vue-good-table
          ref="datatableRef"
          :sort-options="{enabled: true, initialSortBy: datatable.initialSortBy.value}"
          :columns="columns"
          :rows="datatable.rows.value"
          mode="remote"
          @page-change="datatable.onPageChange"
          @sort-change="datatable.onSortChange"
          @column-filter="datatable.onColumnFilter"
          @per-page-change="datatable.onPerPageChange"
          :totalRows="datatable.totalRecords.value"
          :pagination-options="{
                  enabled: true,
                  rowsPerPageLabel: t('usersIndex.entriesPerPage'),
                  nextLabel: t('usersIndex.next'),
                  prevLabel: t('usersIndex.previous'),
                  ofLabel: 'z',
                }">
        <template #table-row="props">
                            <span v-if="props.column.field == 'action'">
                                <span style="font-weight: bold; float: right">
                                    <router-link :to="{ name: 'UserDetail', params: { id: props.row.id} }"><button type="button" class="btn btn-link me-2ß"><i class="mdi mdi-eye"/></button></router-link>
<!--                                    <button type="button" class="btn btn-primary" @click="deleteUser(props.row.id)"><i class="mdi mdi-trash-can-outline"/></button>-->
                                </span>
                            </span>
        </template>
        <template v-slot:emptystate v-if="!datatable.isLoading.value">
          <div class="text-center">
            {{ t('usersIndex.no_records_found') }}
          </div>
        </template>
        <template v-slot:emptystate v-if="datatable.isLoading.value">
          <div class="text-center">
            {{ t('usersIndex.loading') }}
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<style scoped>

</style>
